// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-header {
  justify-content: left !important;
}

.btn {
  margin: 0px !important;
  padding: 3px 6px !important;
  min-height: 22px;
}

.alert-modal {
  position: relative;
  top: 50%;
  z-index: 9999;
  max-width: 600px;
  min-width: 450px;
  width: auto;
  min-height: 100px;
  transform: translate(-50%, -50%);
  left: 50%;
  padding: 0.85rem 0.7rem 0.5rem 0.35rem !important;
  border-radius: 14px;
  border: 1px solid;
  border-left: 15px solid;
  background: #fff;
  box-shadow: 4px 9px 9px rgba(11, 49, 162, 0.35);
  max-height: 500px;
  overflow: auto;
}

.alert-container {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.alert-body {
  margin: 0;
  padding: 0;
  display: inline-block;
}

.alert-footer {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.close {
  cursor: pointer;
}

.header-close {
  display: block;
}

.alert-body-alignment {
  display: grid;
  grid-column-gap: 15px;
  grid-template-columns: 5% auto;
  align-items: center;
  word-break: break-word;
  white-space: break-spaces;
}

.alert-body-alignment i {
  font-size: 1.89rem;
}

.alert-body-alignment span {
  font-size: 0.95rem;
}

/*
commneted only top: 135px and top: 25px beacuse warning pop-up of ocr block is getting below on the screen in Eapp
@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: landscape) {
  .alert-modal {
    top: 135px;
  }

  .alert.alert-dismissable.alert-modal.alert-warning {
    top: 25px;
    // left: -10px !important;
  }
}
*/
@media only screen and (max-width: 768px) {
  .alert-modal {
    min-width: auto;
  }
  .alert-body-alignment span {
    font-size: 0.85rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/system-common/alert/alert.component.scss"],"names":[],"mappings":"AAAA;EACE,gCAAA;AACF;;AACA;EACE,sBAAA;EACA,2BAAA;EACA,gBAAA;AAEF;;AACA;EACE,kBAAA;EACA,QAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,gCAAA;EACA,SAAA;EACA,iDAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,+CAAA;EACA,iBAAA;EACA,cAAA;AAEF;;AACA;EACE,eAAA;EAEA,WAAA;EACA,YAAA;EAEA,MAAA;EACA,OAAA;AAAF;;AAGA;EACE,SAAA;EACA,UAAA;EACA,qBAAA;AAAF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AACA;EACE,kBAAA;AAEF;;AAOA;;;;;;;;;;;;CAAA;AAaA;EACE;IACE,eAAA;EAJF;EAOA;IACE,kBAAA;EALF;AACF","sourcesContent":[".modal-header {\r\n  justify-content: left !important;\r\n}\r\n.btn {\r\n  margin: 0px !important;\r\n  padding: 3px 6px !important;\r\n  min-height: 22px;\r\n}\r\n\r\n.alert-modal {\r\n  position: relative;\r\n  top: 50%;\r\n  z-index: 9999;\r\n  max-width: 600px;\r\n  min-width: 450px;\r\n  width: auto;\r\n  min-height: 100px;\r\n  transform: translate(-50%, -50%);\r\n  left: 50%;\r\n  padding: 0.85rem 0.7rem 0.5rem 0.35rem !important;\r\n  border-radius: 14px;\r\n  border: 1px solid;\r\n  border-left: 15px solid;\r\n  background: #fff;\r\n  box-shadow: 4px 9px 9px rgb(11 49 162 / 35%);\r\n  max-height: 500px;\r\n  overflow: auto;\r\n}\r\n\r\n.alert-container {\r\n  position: fixed;\r\n  // background: rgba(121, 114, 114, 0.78);\r\n  width: 100%;\r\n  height: 100%;\r\n  // z-index: 9999;\r\n  top: 0;\r\n  left: 0;\r\n}\r\n\r\n.alert-body {\r\n  margin: 0;\r\n  padding: 0;\r\n  display: inline-block;\r\n}\r\n.alert-footer {\r\n  display: flex;\r\n  justify-content: center;\r\n  margin-top: 10px;\r\n}\r\n\r\n.close {\r\n  cursor: pointer;\r\n}\r\n\r\n.header-close {\r\n  display: block;\r\n}\r\n\r\n.alert-body-alignment {\r\n  display: grid;\r\n  grid-column-gap: 15px;\r\n  grid-template-columns: 5% auto;\r\n  align-items: center;\r\n  word-break: break-word;\r\n  white-space: break-spaces;\r\n}\r\n\r\n.alert-body-alignment i {\r\n  font-size: 1.89rem;\r\n}\r\n.alert-body-alignment span {\r\n  font-size: 0.95rem;\r\n}\r\n\r\n// @media only screen and (min-width: 992px) {\r\n//   .alert-modal {\r\n//     top: 150px;\r\n//   }\r\n// }\r\n\r\n/*\r\ncommneted only top: 135px and top: 25px beacuse warning pop-up of ocr block is getting below on the screen in Eapp\r\n@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: landscape) {\r\n  .alert-modal {\r\n    top: 135px;\r\n  }\r\n\r\n  .alert.alert-dismissable.alert-modal.alert-warning {\r\n    top: 25px;\r\n    // left: -10px !important;\r\n  }\r\n}\r\n*/\r\n@media only screen and (max-width: 768px) {\r\n  .alert-modal {\r\n    min-width: auto;\r\n  }\r\n\r\n  .alert-body-alignment span {\r\n    font-size: 0.85rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
